import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import { useOtpSettings } from "./OtpContext";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import { Checkbox, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import TableSortLabel from "@mui/material/TableSortLabel";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import DownloadIcon from "@mui/icons-material/Download";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../App.css";
import { Modal } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DialogActions, DialogContentText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getInstituteConfig } from "../utility/instituteConfig";
export default function StorePayment({ props }) {
  let {
    studentId,
    refundBalance,
    setRefundBalance,
    studentName,
    academicYearId,
    gradeName,
    gradeId,
    feesSlabId,
    pendingFees,
    userId,
    sectionName,
    sectionId,
    userMail,
  } = props;

  const [concession, setConcession] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [amountPending, setAmountPending] = useState(0);
  const [paymentMode, setPaymentMode] = useState([{}]);
  const [description, setDescription] = useState("");
  const [dateofbirthError, setDateofbirthError] = useState(false);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [paymentModeId, setPaymentModeId] = useState();
  const [includeRefundBalance, setIncludeRefundBalance] = useState(false);
  const [storePaymentModal, setStorePaymentModal] = useState(false);
  const [amountPayableAfterConcession, setAmountPayableAfterConcession] =
    useState(0);
  const [storePaymentId, setStorePaymentId] = useState(0);
  const [utrId, setUtrId] = useState("");
  const [paymentModeName, setPaymentModeName] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("store_payment_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [storePayment, setStorePayment] = useState([{}]);
  const [amountPayableError, setAmountPayableError] = useState(false);
  const [totalAmountPayable, setTotalAmountPayable] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [concessionError, setConcessionError] = useState("");
  const [totalAmountPaidError, setTotalAmountPaidError] = useState("");
  const [transactionIdError, setTransactionIdError] = useState("");
  const [salesIdError, setsalesIdError] = useState("");
  const [refundBalanceUsed, setRefundBalanceUsed] = useState(0);
  const [remainingRefundBalance, setRemainingRefundBalance] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const { isOtpEnabled } = useOtpSettings();
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempt
  const [oldStudentConcession, setOldStudentConcession] = useState(0);
  const [oldTotalAmountPaid, setOldTotalAmountPaid] = useState(0);
  const [oldAmountPending, setOldAmountPending] = useState(0);
  const [oldPaymentMode, setOldPaymentMode] = useState([]);
  const [oldUtrId, setOldUrtId] = useState("");
  const [oldDescription, setOldDescription] = useState("");
  const [oldRefundBalance, setOldRefundBalance] = useState(refundBalance);
  const [oldPaymentDate, setOldPaymentDate] = useState("");
  const [oldTotalAmountPayable, setOldAmountPayable] = useState(0);
  const [salesId, setSalesId] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [product, setProduct] = useState([]);
  const [open, setOpen] = useState(false);
  const [saleStatus, setSaleStatus] = useState([]);
  const [checkedStates, setCheckedStates] = React.useState({}); // State to track each checkbox
  const [disabledStates, setDisabledStates] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [totalProduct, setTotalProduct] = useState([]);
  const [totalStockQuantity, setTotalStockQuantity] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState([]);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [currentCheckbox, setCurrentCheckbox] = React.useState(null); // Store checkbox details temporarily
  const [paidStatusId, setPaidStatusId] = useState(null);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [staticPendingAmount, setStaticPendingAmount] = useState(null);
  const [selectedSalesId, setSelectedSalesId] = useState(null);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState(""); // Add this line
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const instituteId = localStorage.getItem("instituteId");
  const instituteEmailMap = {
    "1": process.env.REACT_APP_EMAIL_JHS,
    "2": process.env.REACT_APP_EMAIL_JPS,
  };
  const [email, setEmail] = useState(instituteEmailMap[instituteId]);

  useEffect(() => {
    const getFeesReport = async () => {
      fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getFeesReport",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            grade_id: gradeId ? gradeId : null,
            fees_slab_id: feesSlabId ? feesSlabId : null,
            section_id: sectionId ? sectionId : null,
            pending_fees: pendingFees ? true : false,
            // Narrows the DB query to just this student instead of asking
            // for (and decrypting) the entire matching roster to find one
            // row.
            student_id: studentId,
          }),
        },
      )
        .then((response) => response.json())
        .then((response) => {
          const targetStudentId = studentId; // Replace with the actual student ID you're checking for

          // getFeesReport now returns { rows, total } instead of a bare
          // array (added for pagination); unwrap .rows here.
          const rows = Array.isArray(response) ? response : response?.rows || [];

          // Find the student whose studentId matches the target
          const matchingStudent = rows.find(
            (student) => student.student_id === targetStudentId,
          );

          if (matchingStudent) {
            const updatedRefund = matchingStudent.refund_amount;

            if (updatedRefund !== undefined) {
              setRefundBalance((prev) => {
                return updatedRefund;
              });
              console.log(
                "updatedRefund for Student:",
                updatedRefund,
                studentId,
              );
            } else {
              console.error(
                "current_pending_amount not found for the matched student.",
              );
            }
          } else {
            console.error("No student found with the specified studentId.");
          }
        });
    };
    getFeesReport();
  }, [academicYearId, gradeId, feesSlabId, pendingFees]);

  useEffect(() => {
    getProduct();
  }, [studentId, salesId, academicYearId]);
  const getProduct = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/storepurchase/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            student_id: studentId,
            academic_year_id: academicYearId,
          }),
        },
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Assuming `data` is an array of products
      const filteredProducts = data.filter((p) => p.sales_id === salesId);

      if (filteredProducts.length > 0) {
        // Extract all product IDs and set them in the state
        const productIds = filteredProducts.map(
          (product) => product.product_id,
        );
        setTotalProduct(productIds);

        // Extract all stock quantities and set them in the state
        const stock = filteredProducts.map((product) => product.stock);
        setTotalStockQuantity(stock);

        // Extract all quantities and set them in the state
        const quantity = filteredProducts.map((product) => product.quantity);
        setTotalQuantity(quantity);
      } else {
        console.log("No products found for the given sales ID.");
      }

      if (data && data.length > 0) {
        // Get the last item in the array
        const lastItem = data[data.length - 1];
        const salesId = lastItem.sales_id;
        const totalPrice = lastItem.total_price1;

        // Setting state
        setProduct(data);
        if (!storePaymentId) {
          setSalesId(salesId);

          setTotalPrice(totalPrice);
        }
      }
    } catch (error) {}
  };

  const getProduct1 = async (salesId) => {
    console.log("res", salesId);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          // credentials:'include',
          body: JSON.stringify({
            sales_id: salesId,
          }),
        },
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product API response:", data);

      setStatus(data[0].sales_status);

      console.log("status", data[0].sales_status);

      // Only update the product state after data is fetched
      if (data.length > 0) {
        setProduct(data);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const openList = (salesId) => {
    setSelectedSalesId(salesId);
    console.log("salesId", salesId);

    // Fetch product data first
    getProduct1(salesId);
    // Then open the dialog
    setOpen(true);
  };

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"
      const paidStatus =
        data.find((item) => item.description === "Paid")?.sales_status_id ||
        null;
      const issuedStatus =
        data.find((item) => item.description === "Issued")?.sales_status_id ||
        null;

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setPaidStatusId(paidStatus);
      setIssuedStatusId(issuedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  useEffect(() => {
    // Update state if totalPrice prop changes
    if (totalPrice !== undefined) {
      setTotalAmountPayable(totalPrice);
    }
  }, [totalPrice]);

  useEffect(() => {
    setOrder("desc");
    setOrderBy("store_payment_id");
  }, []);

  //download reciept
  const handleDownload = async (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();

    const institute = getInstituteConfig(instituteId);
    // Add Logo and Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    const textyy = 11;
    doc.setFont("helvetica", "bold");

    // School name
    doc.text(
      institute.name, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textyy,
      { align: "center" },
    );

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 8, 1, 28, 18); // ✅ dynamic
    }

    // Address
    doc.setTextColor(0, 0, 0);
    const textStartY = 15;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 10,
      { align: "center" },
    );
    doc.text(
      institute.address2, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel, // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" },
      );
    }
    // Add Receipt Title, Number, and Date
    const receiptTextY = textStartY + 30;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    if (
      row.sale_status === "Issued" ||
      row.sale_status === "Refunded" ||
      row.sale_status === "Partial Refund"
    ) {
      doc.text(
        "STORE PAYMENT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" },
      );
    } else if (row.sale_status === "Paid") {
      doc.text(
        "PROCUREMENT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" },
      );
    }
    doc.setFontSize(10);
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    const studentLabelX = 14;

    // Constants for padding and maximum widths
    const PADDING = 5; // Uniform padding between elements
    const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

    // Handle long student name
    const studentname = `${studentName || ""}`;
    const studentNameWidth = doc.getTextWidth(studentname);
    const splitStudentName =
      studentNameWidth > MAX_NAME_WIDTH
        ? doc.splitTextToSize(studentname, MAX_NAME_WIDTH)
        : studentname;

    doc.text(`Name of Student: `, studentLabelX, studentDetailsY); // Left aligned
    doc.setFont("helvetica", "normal");
    doc.text(splitStudentName, studentLabelX + 30, studentDetailsY); // Adjust X position for student name

    // Dynamically calculate X position for Grade based on student name
    const studentNameActualWidth = Math.min(studentNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
    const gradeX = studentLabelX + 30 + studentNameActualWidth + PADDING;

    // Grade
    doc.setFont("helvetica", "bold");
    doc.text(`Grade:`, gradeX, studentDetailsY);
    const gradeLabelWidth = doc.getTextWidth(`Grade: `);
    doc.setFont("helvetica", "normal");
    const gradeValue = `${gradeName || ""}`;
    doc.text(gradeValue, gradeX + gradeLabelWidth, studentDetailsY);

    // Dynamically calculate X position for Section based on Grade
    const gradeValueWidth = doc.getTextWidth(gradeValue);
    const sectionX = gradeX + gradeLabelWidth + gradeValueWidth + PADDING;

    // Section
    doc.setFont("helvetica", "bold");
    doc.text(`Section:`, sectionX, studentDetailsY);
    const sectionLabelWidth = doc.getTextWidth(`Section: `);
    doc.setFont("helvetica", "normal");
    const sectionValue = `${sectionName || ""}`;
    const sectionValueWidth = doc.getTextWidth(sectionValue);

    // Check if Section exceeds page width and adjust
    if (
      sectionX + sectionLabelWidth + sectionValueWidth >
      doc.internal.pageSize.width
    ) {
      // Move to the next line if it exceeds the page width
      studentDetailsY += 10; // Adjust Y position
      doc.text(`Section:`, studentLabelX, studentDetailsY); // Start from the left
      doc.text(
        sectionValue,
        studentLabelX + sectionLabelWidth,
        studentDetailsY,
      );
    } else {
      // Place Section normally
      doc.text(sectionValue, sectionX + sectionLabelWidth, studentDetailsY);
    }

    // Table for Particulars
    const receiptDetails = [
      { title: "Store Payment ID", value: row.store_payment_id },
      { title: "Intend ID", value: row.sales_id },
      { title: "Amount Paid", value: row.amount_paid },
      { title: "Amount Pending", value: row.amount_pending },
      { title: "Payment Date", value: row.payment_date },
      { title: "Payment Mode", value: row.payment_mode_name },
      { title: "Transaction ID", value: row.transaction_id || "N/A" },
      { title: "Refund Amount Used", value: row.refund_amount_used },
      { title: "Description", value: row.description },
      {
        title: "Status",
        value:
          row.sale_status === "Refunded" || row.sale_status === "Partial Refund"
            ? "Issued"
            : row.sale_status,
      },
    ];

    // Initialize productsValue and totalPrice before the fetch
    let productsValue = "No products found for the given Sales ID."; // Default message
    let totalPrice = 0;

    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/sales/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({ sales_id: row.sales_id }),
        },
      );

      const productDetails = await response.json();

      if (Array.isArray(productDetails) && productDetails.length > 0) {
        totalPrice = productDetails.reduce(
          (sum, product) => sum + (product.price * product.quantity || 0),
          0,
        );

        productsValue = productDetails
          .map(
            (product, index) =>
              `${index + 1}. Product: ${product.product_name}, Quantity: ${
                product.quantity
              }, Price: ${product.price}`,
          )
          .join("\n");
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      productsValue = "Error retrieving product details.";
    }

    // Add the products value to the receiptDetails for rendering
    if (
      row.sale_status === "Issued" ||
      row.sale_status === "Refunded" ||
      row.sale_status === "Partial Refund"
    ) {
      console.log("productsValue", productsValue);
      receiptDetails.push({ title: "Products Issued", value: productsValue }); // Ensure this is included after fetching
    } else if (row.sale_status === "Paid") {
      receiptDetails.push({
        title: "Products To Be Issued",
        value: productsValue,
      });
    }

    // Table settings
    doc.autoTable({
      head: [["Particulars", "Amount"]],
      // body: receiptDetails.map((item) => [item.title, item.value]),

      body: receiptDetails.map((item) => {
        if (item.title === "Status") {
          return [
            { content: item.title, styles: { fontStyle: "normal" } }, // Bold title
            { content: item.value, styles: { fontStyle: "bold" } }, // Bold value
          ];
        } else {
          return [item.title, item.value]; // Normal styling for other rows
        }
      }),

      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 90, halign: "left" }, // Fixed width for the "Particulars" column
        1: { cellWidth: 90, halign: "left" }, // Fixed width for the "Amount" column
      },
      theme: "grid",
    });

    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0",
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    if (
      row.sale_status === "Issued" ||
      row.sale_status === "Refunded" ||
      row.sale_status === "Partial Refund"
    ) {
      doc.setFont("helvetica", "bold");
      doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text("Authorized Signatory", 159, doc.previousAutoTable.finalY + 40);
    } else if (row.sale_status === "Paid") {
      doc.setFont("helvetica", "bold");
      doc.text("Accountant Signature", 14, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 50);
      doc.setFont("helvetica", "bold");
      doc.text("Issuer Signature", 167, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text("Date:", 167, doc.previousAutoTable.finalY + 50);
    }

    // Save the PDF
    if (
      row.sale_status === "Issued" ||
      row.sale_status === "Refunded" ||
      row.sale_status === "Partial Refund"
    ) {
      doc.save(
        `store-payment-receipt_${new Date().toISOString().slice(0, 10)}.pdf`,
      );
    } else if (row.sale_status === "Paid") {
      doc.save(
        `procurement-receipt_${new Date().toISOString().slice(0, 10)}.pdf`,
      );
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure 2-digit day
    return `${year}-${month}-${day}`;
  };
  const [paymentDate, setPaymentDate] = useState(getTodayDate);

  const handleChangePayment = (event) => {
    const selectedMode = event.target.value;
    setPaymentModeName(selectedMode);
    let selectedPaymentMode = paymentMode.find(
      (pm) => pm.payment_mode_name === event.target.value,
    );
    setPaymentModeId(selectedPaymentMode.payment_mode_id);
    setPaymentModeError("");
    if (selectedMode === "Cash" || selectedMode === "Using Refund Balance") {
      setUtrId(""); // Clear the transaction ID when payment mode is Cash
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  // Apply sorting
  const sortedRows = [...storePayment].sort(comparator);

  // Apply pagination
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  useEffect(() => {
    const slab = parseFloat(totalAmountPayable) || 0;
    const concessionAmount = parseFloat(concession) || 0;
    const refund = includeRefundBalance
      ? parseFloat(refundBalanceUsed) || 0
      : 0; // Subtract refund balance only if included

    const newAmountPayable = Math.max(0, slab - concessionAmount - refund); // Ensure non-negative value

    setAmountPayableAfterConcession(newAmountPayable);
  }, [
    totalAmountPayable,
    concession,
    amountPending,
    includeRefundBalance,
    refundBalanceUsed,
  ]);

  useEffect(() => {
    const payableAfterConcession =
      parseFloat(amountPayableAfterConcession) || 0;
    const paidAmount = parseFloat(totalAmountPaid) || 0;

    const newAmountPending = Math.max(0, payableAfterConcession - paidAmount); // Ensure non-negative value

    setAmountPending(newAmountPending);
  }, [amountPayableAfterConcession, totalAmountPaid]);

  useEffect(() => {
    // Parse all necessary values, fallback to 0 if any are invalid
    let slab = parseFloat(totalAmountPayable) || 0; // Total amount payable
    let concessionAmount = parseFloat(concession) || 0; // Concession provided
    let refundBalanceAmount = parseFloat(refundBalance) || 0; // Initial refund balance
    let amountPaid = parseFloat(totalAmountPaid) || 0; // Amount that has been paid

    // Calculate the amount payable after concession
    let payableAfterConcession = slab - concessionAmount;
    payableAfterConcession = Math.max(payableAfterConcession, 0); // Ensure it is not negative

    // Calculate the amount pending as the amount after concession minus the amount paid
    let amountPending = payableAfterConcession - amountPaid;
    amountPending = Math.max(amountPending, 0); // Ensure it is not negative

    // Initialize refund balance usage
    let refundBalanceUsed = 0;
    let remainingRefundBalance = refundBalanceAmount;

    // Check if the refund balance should be included
    if (includeRefundBalance) {
      // Apply only the portion of the refund balance that is less than or equal to the amountPending
      refundBalanceUsed = Math.min(remainingRefundBalance, amountPending); // Refund usage is limited to the lesser of the two

      // Update the amount pending by reducing it by the refund balance used

      amountPending -= refundBalanceUsed;

      // Update the remaining refund balance
      remainingRefundBalance -= refundBalanceUsed;

      if (staticPendingAmount === null) {
        setStaticPendingAmount(amountPending);
      }
    }

    // Ensure that the amountPending and remainingRefundBalance are not negative
    amountPending = Math.max(amountPending, 0);
    remainingRefundBalance = Math.max(remainingRefundBalance, 0);

    // Update the state with the calculated values
    setAmountPayableAfterConcession(payableAfterConcession);
    setAmountPending(amountPending);
    // setTotalAmountPaid(amountPaid);
    setRemainingRefundBalance(remainingRefundBalance);
    setRefundBalanceUsed(refundBalanceUsed);
  }, [
    totalAmountPayable,
    concession,
    refundBalance,
    includeRefundBalance,
    // totalAmountPaid,
  ]);

  const handleTransactionIdPopup = () => {
    setStorePaymentModal(false);
  };

  const handleSelectRow = (
    storePaymentId,
    salesId,
    totalPrice,
    concession,
    totalAmountPaid,
    amountPending,
    paymentDate,
    paymentModeName,
    paymentModeId,
    refundBalance,
    refundBalanceUsed,
    transactionId,
    description,
  ) => {
    setStorePaymentId(storePaymentId);
    setSalesId(salesId);
    setTotalPrice(totalPrice);
    console.log("total Price", totalPrice);

    // Check if this logs the correct value
    setConcession(concession);
    setRefundBalance(refundBalance);

    // Only calculate amountPayableAfterConcession if it hasn't been set yet or is 0
    if (!amountPayableAfterConcession || amountPayableAfterConcession === 0) {
      let calculatedAmountPayableAfterConcession =
        totalAmountPayable - concession;
      calculatedAmountPayableAfterConcession -= refundBalance; // Adjust based on refund balance
      setAmountPayableAfterConcession(calculatedAmountPayableAfterConcession);
    }

    setTotalAmountPaid(totalAmountPaid);

    setAmountPending(amountPending);

    setPaymentModeName(paymentModeName);
    setPaymentModeId(paymentModeId);

    // Convert the paymentDate to YYYY-MM-DD format
    const formattedDate = new Date(paymentDate).toISOString().split("T")[0];
    setPaymentDate(formattedDate); // Set the formatted date

    setUtrId(transactionId);
    setDescription(description);

    // Clear any previous errors
    setsalesIdError("");
    setAmountPayableError("");
    setTotalAmountPaidError("");
    setPaymentModeError("");
    setOldAmountPending(amountPending);
    setOldStudentConcession(concession);
    setOldTotalAmountPaid(totalAmountPaid);
    setOldPaymentDate(paymentDate);
    setOldPaymentMode(paymentModeName);
    setOldUrtId(transactionId);
    setOldDescription(description);
    setOldAmountPayable(totalAmountPayable);
  };

  const addPaymentDetails = async () => {
    // e.preventDefault(); // Prevent default form submission behavior

    let totalAmountPaidError = "";
    let dateofbirthError = "";
    let paymentModeError = "";
    let amountPayableError = "";
    let transactionIdError = "";
    let salesIdError = "";

    // Validate amount payable
    if (!totalAmountPayable || parseFloat(totalAmountPayable) === 0) {
      amountPayableError = "Amount Payable is required";
    } else if (parseFloat(totalAmountPayable) < 0) {
      amountPayableError = "Amount Payable can't negative";
    }

    // Validate Addon Type
    if (!salesId || parseFloat(salesId) === 0) {
      salesIdError = "Sales Id is required";
    }

    // Validate amount paid
    if (!includeRefundBalance) {
      if (
        (!totalAmountPaid ||
          totalAmountPaid === "" ||
          isNaN(parseFloat(totalAmountPaid))) &&
        amountPending !== 0
      ) {
        totalAmountPaidError = "Amount Paid is required";
      } else if (parseFloat(totalAmountPaid) < 0) {
        totalAmountPaidError = "Amount Paid can't negative";
      } else if (
        amountPayableAfterConcession &&
        parseFloat(totalAmountPaid) > amountPayableAfterConcession
      ) {
        totalAmountPaidError = "Amount can't exceed amount after concession";
      } else if (
        !concession &&
        parseFloat(totalAmountPaid) > parseFloat(totalAmountPayable)
      ) {
        totalAmountPaidError = "Amount can't exceed store payment";
      }
    } else if (includeRefundBalance) {
      if (
        (!totalAmountPaid ||
          totalAmountPaid === "" ||
          isNaN(parseFloat(totalAmountPaid))) &&
        amountPending !== 0
      ) {
        totalAmountPaidError = "Amount Paid is required";
      } else if (parseFloat(totalAmountPaid) < 0) {
        totalAmountPaidError = "Amount Paid cannot be negative";
      } else if (
        amountPayableAfterConcession &&
        parseFloat(totalAmountPaid) > amountPayableAfterConcession
      ) {
        totalAmountPaidError = "Amount can't exceed amount after concession";
      } else if (
        !concession &&
        parseFloat(totalAmountPaid) > parseFloat(totalAmountPayable)
      ) {
        totalAmountPaidError =
          "Amount can't exceed annual subscription payment";
      }
    }
    if (
      (paymentModeName === "UPI" || paymentModeName === "DD/Cheque") &&
      (!utrId || utrId.trim() === "")
    ) {
      transactionIdError =
        paymentModeName === "DD/Cheque"
          ? "DD/Cheque number is required."
          : "Transaction ID is required.";
    }
    // Set the error state
    // Validate payment date
    if (!paymentDate) {
      dateofbirthError = "Payment date is required";
    }

    // Validate payment mode
    if (
      !paymentModeId ||
      paymentModeId === "" ||
      parseFloat(paymentModeId) === 0
    ) {
      paymentModeError = "Payment Mode is required";
    }
    console.log("payment", paymentMode);

    if (includeRefundBalance) {
      if (
        parseFloat(totalAmountPaid) > parseFloat(staticPendingAmount) &&
        parseFloat(amountPending) === 0 &&
        parseFloat(staticPendingAmount) !== 0
      ) {
        totalAmountPaidError = "Amount can't exceed amount pending.";
      }
    }

    // Set errors and stop form submission if there are any errors
    if (
      totalAmountPaidError ||
      dateofbirthError ||
      paymentModeError ||
      amountPayableError ||
      transactionIdError ||
      salesIdError
    ) {
      setTotalAmountPaidError(totalAmountPaidError);
      setDateofbirthError(dateofbirthError);
      setPaymentModeError(paymentModeError);
      setAmountPayableError(amountPayableError);
      setTransactionIdError(transactionIdError);
      setsalesIdError(salesIdError);
      return;
    }

    // Clear errors if no issues
    setTotalAmountPaidError("");
    setConcessionError("");
    setDateofbirthError("");
    setPaymentModeError("");
    setAmountPayableError("");
    setTransactionIdError("");
    setsalesIdError("");
    console.log("concession", concession);
    setIsLoading(true); // Start loading
    try {
      // Proceed with form submission for payment
      console.log("refund amount", refundBalanceUsed);

      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storePayment/saveStorePayment`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            store_payment_id: storePaymentId,
            student_id: studentId,
            sales_id: salesId,
            amount_payable: totalAmountPayable,
            concession: isNaN(concession) ? "0.00" : concession,
            amount_paid: isNaN(totalAmountPaid) ? "0.00" : totalAmountPaid,
            amount_pending: amountPending,
            payment_mode_id: paymentModeId,
            transaction_id: utrId,
            payment_date: paymentDate,
            refund_amount: refundBalance,
            academic_year_id: academicYearId,
            description: description,
            refund_amount_used: refundBalanceUsed,
            remaining_refund_balance: remainingRefundBalance,
            created_by: userId,
          }),
        },
      );

      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      // Check for response status
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      handleResponse(data); // Handle payment response

      // Check if amountPending is 0 before updating sale status
      if (parseFloat(amountPending) === 0) {
        const createResponse = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateSaleStatusSave`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              sales_id: salesId,
              updated_by: userId,
              updated_timestamp: new Date(),
              sale_status_id: paidStatusId,
              sale_date: new Date(),
            }),
          },
        );

        // Check for sale update response status
        if (!createResponse.ok) {
          throw new Error(
            `HTTP error while updating sale status! Status: ${createResponse.status}`,
          );
        }
        getStorePayment();
      }
    } catch (error) {
    } finally {
      setIsLoading(false); // ✅ This is correct
    }
  };

  const editPaymentDetails = () => {
    // Proceed with form submission
    fetch(
      `${process.env.REACT_APP_JHS_DEVELOPMENT}/storePayment/editStorePayment`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          store_payment_id: storePaymentId,
          student_id: studentId,
          sales_id: salesId,
          payment_mode_id: paymentModeId,
          transaction_id: utrId,
          payment_date: paymentDate,

          academic_year_id: academicYearId,
          description: description,

          updated_timestamp: new Date(),

          updated_by: userId,
        }),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Handle the response directly here

        handleResponse(data);
      })
      .catch((error) => {});
  };

  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getStorePayment();
      setStorePaymentModal(false);
      const message = storePaymentId ? "Payment updated successfully" : "Payment added successfully";
      setSnackbarMessage(message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      handleResetForm();
    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };
  const handleResetForm = () => {
    setStorePaymentId("");
    setSalesId("");
    setTotalAmountPayable("");
    setConcession("");
    setAmountPayableAfterConcession("");
    setTotalAmountPaid("");
    setAmountPending("");
    setPaymentModeId(null);
    setPaymentDate(getTodayDate);
    setPaymentModeName("");

    setUtrId("");
    setDescription("");
    setTotalPrice("");

    setTimeout(() => {
      setRefundBalance(remainingRefundBalance); // Now set the refund balance
    }, 2000);
  };

  const reset = () => {
    setStorePaymentId("");
    setSalesId("");
    setTotalAmountPayable("");
    setConcession("");
    setAmountPayableAfterConcession("");
    setTotalAmountPaid("");
    setAmountPending("");
    setPaymentModeName("");
    setPaymentModeId(null);
    setPaymentDate(getTodayDate);
    setUtrId("");
    setDescription("");
  };

  const handleConcessionChange = (event) => {
    const value = event.target.value;
    let numericValue = parseFloat(value);

    let error = ""; // Use a string for a single error message

    const paidAmount = parseFloat(totalAmountPaid) || 0;

    const payableAmount = parseFloat(totalAmountPayable) || 0;

    const refuundAmount = parseFloat(refundBalanceUsed) || 0;

    // Perform validation

    if (numericValue > payableAmount - paidAmount) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(
        value.slice(0, String(payableAmount - paidAmount).length),
      ); // Truncate the value
    }
    if (includeRefundBalance && numericValue > payableAmount - refuundAmount) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(
        value.slice(0, String(payableAmount - refuundAmount).length),
      ); // Truncate the value
    } else if (
      includeRefundBalance &&
      paidAmount > 0 &&
      numericValue > payableAmount - paidAmount - refuundAmount
    ) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(
        value.slice(
          0,
          String(payableAmount - paidAmount - refuundAmount).length,
        ),
      ); // Truncate the value
    } else if (numericValue < 0) {
      error = "Concession should not be negative.";
      numericValue = Number(
        value.slice(0, String(payableAmount - paidAmount).length),
      ); // Truncate the value
    } else {
      delete error.concession;
    }

    // Update state
    setConcession(numericValue); // Set the updated value
    setConcessionError(error); // Set the error message
  };

  const handleAmountPaidChange = (event) => {
    const value = event.target.value;
    let numericValue = parseFloat(value); // Use `let` for reassignment

    let error = ""; // Use a string for a single error message

    // Perform validation
    if (
      !amountPayableAfterConcession &&
      parseFloat(value) > totalAmountPayable
    ) {
      error = "Amount can't exceed amount payable.";
      numericValue = Number(value.slice(0, String(totalAmountPayable).length)); // Truncate the value
    } else if (
      amountPayableAfterConcession &&
      parseFloat(value) > amountPayableAfterConcession
    ) {
      error = "Amount can't exceed amount after concession.";
      numericValue = Number(
        value.slice(0, String(amountPayableAfterConcession).length),
      ); // Truncate the value
    } else {
      delete error.totalAmountPaid;
    }

    if (includeRefundBalance) {
      if (staticPendingAmount && parseFloat(value) > staticPendingAmount) {
        error = " Amount can't exceed amount pending.";
        numericValue = Number(
          value.slice(0, String(staticPendingAmount).length),
        ); // Truncate the value
      }
    }

    // Update state
    setTotalAmountPaid(numericValue); // Set the updated value
    setTotalAmountPaidError(error); // Set the error message
  };

  useEffect(() => {
    getStorePayment();
  }, [academicYearId, studentId]);

  const getStorePayment = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/storePayment/getStorePayment",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            student_id: studentId,
          }),
        },
      );

      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Extract the array from the response object
      if (data && data.fn_get_store_payments_by_student_id_academic_year_id) {
        const storePayments =
          data.fn_get_store_payments_by_student_id_academic_year_id;
        // Set the array to your state
        setStorePayment(storePayments);
        console.log("storePayments", storePayments);
      } else {
        setStorePayment([]); // Set empty array if data is not as expected
      }
    } catch (error) {}
  };

  const handleCheckboxChange = (event) => {
    setIncludeRefundBalance(event.target.checked);

    // Update the updated refund balance based on the checkbox state
    if (event.target.checked) {
      setRefundBalance(refundBalance); // If fully included, set to 0
    }
  };

  const getPaymentMode = async () => {
    fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/paymentMode/getPaymentMode",
      {
        method: "GET",
        headers: { "Content-type": "application/json" },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        setPaymentMode(response);
      });
  };

  useEffect(() => {
    getPaymentMode();
  }, []);
  const handleGetOtp = async () => {
    const otpRequiredForStorePayment = isOtpEnabled('StorePayment');
    if (!otpRequiredForStorePayment) {
    if (storePaymentId) {
      // ✅ Check for changes before saving
      const hasChanges =
        oldPaymentMode !== paymentModeName ||
        oldUtrId !== utrId ||
        oldPaymentDate !== paymentDate ||
        oldDescription !== description;

      if (!hasChanges) {
        setSnackbarMessage("No changes detected.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        return;
      }

      editPaymentDetails();
    } else {
      addPaymentDetails();
    }
    return;
  }
    setSnackbarMessage("OTP sent successfully.");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
    try {
      const paymentDetails = {
        payment_mode_name: paymentModeName,
        transaction_id: utrId,
        payment_date: paymentDate,
        description: description,
      };
      const paymentType = "Store Payment";
      const paymentId = storePaymentId;

      // Assuming you have a way to get the oldPaymentDetails
      const oldPaymentDetails = {
        amount_payable: oldTotalAmountPayable,
        concession: oldStudentConcession,
        amount_paid: oldTotalAmountPaid,
        amount_pending: oldAmountPending,
        payment_mode_name: oldPaymentMode,
        transaction_id: oldUtrId,
        payment_date: oldPaymentDate,
        refund_amount: oldRefundBalance,
        description: oldDescription,
      };

      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/send-otp/getOtp",
        {
          email,
          userMail,
          paymentId,
          updatedPaymentDetails: paymentDetails,
          oldPaymentDetails: oldPaymentDetails, // Include old details here
          userId: userId,
          paymentType,
          studentName,
          gradeName,
          sectionName,
          created_by: userId,
        },
        { withCredentials: "true" },
      );

      if (response.data.otp) {
        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        setIsOtpModalOpen(true); // Open OTP modal
      }
    } catch (error) {
      setSnackbarMessage("No changes detected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fix: Ensure correct spelling
        return;
      }
      // setTimeout(() => {
      //   reset();
      // }, 2000);
    }
  };

  const handleVerifyOtp = (event) => {
    event.preventDefault();
    const enteredOtp = otp.join(""); // Combine the entered OTP from the input boxes

    // Check if the OTP field is empty
    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    // Check if the entered OTP matches the backend OTP
    if (enteredOtp === backendOtp) {
      setVerifyOTPMsg("OTP Verified Successfully");
      editPaymentDetails();
      setIsOtpModalOpen(false); // Close the modal on successful verification
      setOtp(["", "", "", "", "", ""]);
      setVerifyOTPMsg(""); // Clear any verification message
      setResendCount(0); // Reset resend count
      setResendTimer(600); // Reset resend timer
      setCanResend(true); // Disable resend button
    } else {
      setVerifyOTPMsg("Invalid OTP"); // Show this if the OTP is incorrect
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus on the next input
      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
      // Focus on the previous input
      if (value === "" && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  // Add this useEffect to handle the countdown timer
  useEffect(() => {
    let intervalId;

    if (isOtpModalOpen && resendTimer > 0 && !canResend) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            clearInterval(intervalId);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isOtpModalOpen, canResend, resendTimer]);

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const handleResendOtp = () => {
    if (canResend && resendCount < 3) {
      setResendCount((prev) => prev + 1);
      handleGetOtp(); // Triggers OTP generation and email
      setCanResend(false); // Disable until timer ends
      setResendTimer(600); // Restart the timer
    } else {
      setVerifyOTPMsg(
        "You have reached the maximum number of resend attempts.",
      );
    }
  };

  const handleCloseModal = () => {
    setIsOtpModalOpen(false);

    // Reset all states related to OTP input, verification, and timers
    setOtp(["", "", "", "", "", ""]); // Reset OTP fields
    setVerifyOTPMsg(""); // Clear any verification message
    setResendCount(0); // Reset resend count
    setResendTimer(600); // Reset resend timer
    setCanResend(true); // Disable resend button
    setStorePaymentId("");
    handleResetForm();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateSaleStatus = async (selectedSalesId) => {
    // const checked = event.target.checked;
    console.log("salesId", selectedSalesId);
    try {
      // Send the PUT request to update sale status
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/updateSaleStatus`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            sales_id: selectedSalesId,
            updated_by: userId,
            updated_timestamp: new Date(),
            sale_status_id: issuedStatusId, // Set the desired sale status ID
            product_id: totalProduct,
            stock: totalStockQuantity,
            quantity: totalQuantity,
            issue_date: new Date(),
          }),
        },
      );

      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      // Check for response status
      if (!response.ok) {
        throw new Error(
          `HTTP error while updating sale status! Status: ${response.status}`,
        );
      }

      // Parse the response data
      const result = await response.json();

      // Return result if further processing is needed
      return result;
    } catch (error) {}
  };

  // Load disabled states from localStorage on component mount
  useEffect(() => {
    const savedDisabledStates =
      JSON.parse(localStorage.getItem("disabledStates")) || {};
    setDisabledStates(savedDisabledStates);
  }, []);

  const handleCheckboxClick = async (
    event,
    storePaymentId,
    selectedSalesId,
  ) => {
    const checked = event.target.checked;

    // Update the state for the specific checkbox and disable it simultaneously
    setCheckedStates((prevState) => ({
      ...prevState,
      [storePaymentId]: checked,
    }));

    // Update the disabled state
    const updatedDisabledStates = {
      ...disabledStates,
      [storePaymentId]: checked,
    };
    setDisabledStates(updatedDisabledStates);

    // Save disabled states to localStorage
    localStorage.setItem(
      "disabledStates",
      JSON.stringify(updatedDisabledStates),
    );
    // setSelectedSalesId(selectedSalesId)
    try {
      // Ensure `updateSaleStatus` API call happens only if `checked` is true
      if (checked) {
        await updateSaleStatus(selectedSalesId); // Pass the correct ID
        console.log(
          `Sale status updated for storePaymentId: ${selectedSalesId}`,
        );
      }
      // Fetch updated data after updating the sale status
      await getStorePayment();
    } catch (error) {
      console.error(
        "Error while updating sale status or fetching subscriptions:",
        error,
      );
    }
  };

  const handleDialogOpen = (paymentRow) => {
    const { store_payment_id, sales_id } = paymentRow;

    // If sales/indent id is not present, do not open the product list
    if (!sales_id || sales_id === "" || Number(sales_id) === 0) {
      setSnackbarMessage("Products not available");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }

    // Set state for the selected checkbox and dialog
    setCurrentCheckbox({ storePaymentId: store_payment_id, salesId: sales_id }); // Ensure property names match

    if (paymentRow.sale_status === "Paid") {
      setDialogMessage(
        `Are you sure you want to update status for Indent ID ${paymentRow.sales_id} from "Paid" to "Issued"?`,
      );
      setDialogType("confirmation");
    }
    setSelectedSalesId(sales_id);
    console.log("paymentRow Sales Id:", paymentRow.sales_id);
    console.log("paymentRow Sales Details:", paymentRow.sales_details);

    // ✅ Check if sales_details exists before mapping
    if (!paymentRow.sales_details || paymentRow.sales_details.length === 0) {
      console.warn("⚠️ No sales details found for this row.");
      setTotalProduct([]);
      setTotalQuantity([]);
      setTotalStockQuantity([]);
      // Show snackbar to inform user
      setSnackbarMessage("Products not available");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }

    // ✅ Extract product IDs, quantities, and stock correctly
    const productIds = paymentRow.sales_details.map((item) => item.product_id);
    const quantities = paymentRow.sales_details.map(
      (item) => item.sales_quantity,
    );
    const stocks = paymentRow.sales_details.map(
      (item) => item.product_quantity,
    );

    // ✅ Check for out-of-stock products
    const outOfStockIndex = stocks.findIndex((stock) => stock <= 0);
    if (outOfStockIndex !== -1 && paymentRow.sale_status === "Paid") {
      setDialogMessage(
        `Products cannot be issued as stock is not available for Product ID ${productIds[outOfStockIndex]}.`,
      );
      setDialogType("error");
      setDialogOpen(true);
      return;
    }

    // ✅ Store in state
    setTotalProduct(productIds);
    setTotalQuantity(quantities);
    setTotalStockQuantity(stocks);

    // ✅ Open the dialog
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setCurrentCheckbox(null);
  };

  const handleDialogConfirm = () => {
    if (currentCheckbox) {
      const { storePaymentId, salesId } = currentCheckbox;
      handleCheckboxClick(
        { target: { checked: true } },
        storePaymentId,
        salesId,
      );
    }
    setDialogOpen(false);
  };

  return (
    <div>
      <div className="main_title">Store Payment</div>
      <br />

      <Dialog onClose={handleTransactionIdPopup} open={storePaymentModal}>
        <DialogTitle
          alignSelf={"left"}
          style={{
            paddingBottom: "0",
            marginLeft: "9px",
            marginRight: "6px",
            color: "#0A64A2",
          }}
        >
          {
            storePaymentId
              ? paymentModeName === "DD/Cheque"
                ? "Edit DD/Cheque No"
                : "Edit Transaction ID" // If feePaymentId exists
              : paymentModeName === "DD/Cheque"
                ? "Add DD/Cheque No"
                : "Add Transaction ID" // If feePaymentId does not exist
          }
          <Divider className="divider" />
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleTransactionIdPopup}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Stack spacing={4} padding={1}>
            <TextField
              id="outlined-basic"
              value={utrId}
              onChange={(event) => {
                setUtrId(event.target.value);
                setTransactionIdError("");
              }}
              size="small"
              label={
                transactionIdError
                  ? transactionIdError // Show error as label if present
                  : paymentModeName === "DD/Cheque"
                    ? "Enter DD/Cheque No" // Change label based on payment mode
                    : "Enter Transaction ID"
              } // Default label
              variant="outlined"
              inputProps={{ maxLength: 20 }}
              error={!!transactionIdError}
            />
            <div className="button-container">
              <Button
                className="save_update_btn"
                variant="contained"
                onClick={() => {
                  setStorePaymentModal(false);

                  let transactionIdError = "";
                  if (
                    (paymentModeName === "UPI" ||
                      paymentModeName === "DD/Cheque") &&
                    (!utrId || utrId.trim() === "")
                  ) {
                    transactionIdError =
                      paymentModeName === "DD/Cheque"
                        ? "DD/Cheque number is required."
                        : "Transaction ID is required.";
                  }

                  if (transactionIdError) {
                    setStorePaymentModal(true);
                    setTransactionIdError(transactionIdError);
                    return;
                  }

                  setTransactionIdError("");
                }}
              >
                {storePaymentId ? <>Update</> : <>Save</>}
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>

      <Stack spacing={8} direction="row">
        <Stack spacing={1} direction="column">
          <Box display="flex" alignItems="center">
            <TextField
              disabled
              required
              className="text-field"
              size="small"
              id="demo-simple-select"
              label={salesIdError ? salesIdError : "Indent ID"}
              value={totalPrice === 0 ? "" : salesId}
              name="salesId"
              onChange={(event) => {
                console.log("New Total Amount Payable:", event.target.value);
                setSalesId(event.target.value); // Ensure you pass the value to setSalesId
                setsalesIdError(""); // Clear error message on change
              }}
              InputLabelProps={{ shrink: true }}
              error={!!salesIdError}
              type="number"
            />
            <ListAltIcon
              style={{ marginLeft: 8, color: "#0A64A2", cursor: 'pointer' }}
              onClick={() => {
                // If sales/indent id is not present, do not open the product list
                if (!salesId || salesId === "" || Number(salesId) === 0) {
                  setSnackbarMessage("Products not available");
                  setSnackbarMessageColor("error");
                  setShowSnackbarMessage(true);
                  return;
                }
                openList(salesId);
              }}
            />{" "}
            {/* Add some margin for spacing */}
            {/* Product List Dialog */}
            <Dialog
              open={open}
              onClose={handleClose}
              maxWidth="lg" // Set the maximum width to "small"
              fullWidth={false} // Ensure the dialog does not take the full width
              PaperProps={{
                style: {
                  maxHeight: "90vh", // Limit the maximum height
                },
              }}
            >
              <IconButton
                onClick={handleClose}
                style={{ color: "#817575", position: "absolute", right: "4px" }}
              >
                <CloseIcon />
              </IconButton>
              <Box>
                <DialogTitle
                  style={{
                    color: "#0A64A2",
                    padding: "0px 11px", // Adjust padding for a more compact look
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "0",
                    marginTop: "15px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ListAltIcon
                      style={{ paddingBottom: "0", marginBottom: "4px" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      Product List for Indent Id {salesId}
                    </span>
                  </div>
                </DialogTitle>
              </Box>
              <Divider
                className="divider"
                style={{ width: "94%", marginLeft: "13px" }}
              />
              <DialogContent style={{ padding: "0", margin: "10px 10px" }}>
                {" "}
                {/* Adjusted margin and padding */}
                {product.filter((p) => p.sales_id === salesId).length > 0 ? (
                  <Table size="small">
                    {" "}
                    {/* Use small table size */}
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                          Product Name
                        </TableCell>
                        <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                          Attribute
                        </TableCell>
                        <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                          Price
                        </TableCell>
                        <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                          Quantity
                        </TableCell>
                        <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                          Total Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {product
                        .filter((p) => p.sales_id === salesId) // Filter products by sale_id
                        .map((p) => (
                          <TableRow key={p.product_id}>
                            <TableCell align="left" style={{ padding: "4px" }}>
                              {p.product_name}
                            </TableCell>
                            <TableCell align="left" style={{ padding: "4px" }}>
                              {p.attribute_value}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ padding: "4px" }}
                            >
                              {p.price}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ padding: "4px" }}
                            >
                              {p.quantity}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ padding: "4px" }}
                            >
                              {p.total_price}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                ) : (
                  <p style={{ margin: "10px", textAlign: "center" }}>
                    No products available.
                  </p> // Center the message
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "10px",
                    fontWeight: "bold",
                    fontSize: "0.9rem",
                    marginTop: "5px",
                  }}
                >
                  <span style={{ color: "#0a64a2" }}>Total Price :</span>
                  &nbsp;
                  <span style={{ color: "rgb(58 48 48 / 87%)" }}>
                    {product
                      .filter((p) => p.sales_id === salesId) // Calculate total price for filtered products
                      .reduce((acc, p) => acc + p.total_price, 0)
                      .toFixed(2)}
                  </span>
                </div>
              </DialogContent>
            </Dialog>
          </Box>

          <TextField
            required
            disabled
            error={!!amountPayableError}
            id="outlined-basic"
            value={totalPrice}
            size="small"
            label={
              amountPayableError ? amountPayableError : "Total Amount Payable"
            }
            variant="outlined"
            type="number"
            inputProps={{ maxLength: 10 }}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            id="outlined-basic"
            type="number"
            name="concession"
            value={concession}
            onChange={(event) => {
              handleConcessionChange(event);
            }}
            label={concessionError ? concessionError : "Concession"}
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            error={!!concessionError}
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (concession === 0) {
                setConcession("");
              }
            }}
            disabled={
              ((concession === amountPending || concession === "") &&
                amountPending === 0) ||
              storePaymentId
            }
          />
        </Stack>
        <Stack spacing={1} direction="column">
          <TextField
            id="outlined-basic"
            disabled
            value={amountPayableAfterConcession}
            onChange={(event) => {
              setAmountPayableAfterConcession(event.target.value);
            }}
            size="small"
            label="Amount after Concession"
            variant="outlined"
            type="number"
            InputLabelProps={{ shrink: true }}
            className="text-field"
          />

          <TextField
            id="outlined-basic"
            error={!!totalAmountPaidError}
            type="number"
            value={totalAmountPaid}
            size="small"
            onChange={(event) => {
              handleAmountPaidChange(event);
            }}
            label={
              totalAmountPaidError ? totalAmountPaidError : "Total Amount Paid"
            }
            required
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (totalAmountPaid === 0) {
                setTotalAmountPaid("");
              }
            }}
            className="text-field"
            disabled={
              ((totalAmountPaid === amountPending ||
                totalAmountPaid === "" ||
                isNaN(totalAmountPaid)) &&
                amountPending === 0) ||
              storePaymentId
            }
          />

          <TextField
            id="outlined-basic"
            value={amountPending}
            onChange={(event) => {
              setAmountPending(event.target.value);
            }}
            size="small"
            label="Amount Pending"
            variant="outlined"
            type="number"
            disabled
          />
        </Stack>

        <Stack spacing={1} direction="column">
          <Box sx={{ minWidth: 260 }}>
            <TextField
              id="outlined-basic"
              required
              type="date"
              defaultValue={null}
              value={paymentDate}
              onChange={(event) => {
                setPaymentDate(event.target.value);
                setDateofbirthError("");
              }}
              size="small"
              variant="outlined"
              label={dateofbirthError ? dateofbirthError : "Payment Date"}
              error={!!dateofbirthError}
              InputLabelProps={{ shrink: true }}
              sx={{
                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                  cursor: "pointer", // Change cursor to pointer for the calendar icon
                },
              }}
              className="text-field"
            />
          </Box>

          <Box sx={{ minWidth: 250 }}>
            <TextField
              className="text-field"
              size="small"
              label={
                paymentModeError ? paymentModeError : "Select Payment Mode"
              }
              error={!!paymentModeError}
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={paymentModeName}
              name="paymentModeName"
              select
              onChange={handleChangePayment}
              InputLabelProps={{ shrink: true }}
            >
              {paymentMode.map((pm) => {
                return (
                  <MenuItem
                    key={pm.payment_mode_id}
                    value={pm.payment_mode_name}
                  >
                    {pm.payment_mode_name}
                  </MenuItem>
                );
              })}
            </TextField>
          </Box>

          <TextField
            id="outlined-basic"
            value={utrId}
            onClick={() => {
              if (
                !paymentModeName ||
                paymentModeName === "Cash" ||
                paymentModeName === "Using Refund Balance"
              ) {
                setStorePaymentModal(false);
              } else {
                setStorePaymentModal(true);
              }
            }}
            onChange={(event) => {
              setUtrId(event.target.value);
            }}
            size="small"
            label={
              transactionIdError
                ? transactionIdError // Show error as label if present
                : paymentModeName === "DD/Cheque"
                  ? "Enter DD/Cheque No" // Change label based on payment mode
                  : "Enter Transaction ID"
            } // Default label
            disabled={
              !paymentModeName ||
              paymentModeName === "Cash" ||
              paymentModeName === "Using Refund Balance"
            }
            variant="outlined"
            inputProps={{ maxLength: 20 }}
            InputLabelProps={{ shrink: true }}
            error={!!transactionIdError}
            className="text-field"
            InputProps={{ readOnly: "true" }}
          />
        </Stack>
        <Stack spacing={1} direction="column">
          <Stack spacing={1} direction="row">
            <TextField
              id="outlined-basic"
              disabled
              value={refundBalance}
              onChange={(event) => {
                setRefundBalance(event.target.value);
              }}
              size="small"
              label="Refund Balance"
              variant="outlined"
              className="text-field1"
              InputLabelProps={{ shrink: true }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeRefundBalance}
                  onChange={handleCheckboxChange}
                />
              }
              label="Include"
            />
          </Stack>

          <TextField
            id="outlined-basic"
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
            multiline
            className="description-field1"
            rows={2}
            inputProps={{ maxLength: 250 }}
            label="Description"
            variant="outlined"
          />

          <Button
            className="save_update_btn"
            variant="contained"
            disabled={isLoading}
            onClick={() => {
              if (storePaymentId) {
                let totalAmountPaidError = "";
                let dateofbirthError = "";
                let paymentModeError = "";
                let amountPayableError = "";
                let transactionIdError = "";
                let salesIdError = "";

                if (
                  !totalAmountPayable ||
                  parseFloat(totalAmountPayable) === 0
                ) {
                  amountPayableError = "Amount Payable is required";
                } else if (
                  !totalAmountPayable ||
                  parseFloat(totalAmountPayable) < 0
                ) {
                  amountPayableError = "Amount Payable can't negative";
                } else if (amountPending === 0) {
                  amountPayableError = "";
                }

                // Validate Addon Type
                if (!salesId || salesId === "" || parseFloat(salesId) === 0) {
                  salesIdError = "Sales Id is required";
                }

                // Validate amount paid

                if (!includeRefundBalance) {
                  if (!totalAmountPaid || parseFloat(totalAmountPaid) === "") {
                    totalAmountPaidError = "Amount Paid is required";
                  } else if (
                    !totalAmountPaid ||
                    parseFloat(totalAmountPaid) < 0
                  ) {
                    totalAmountPaidError = "Amount Paid is can't negative";
                  } else if (
                    concession &&
                    parseFloat(totalAmountPaid) >
                      parseFloat(totalAmountPayable) - parseFloat(concession)
                  ) {
                    totalAmountPaidError =
                      "Amount Paid can't greater than the amount after concession";
                  } else if (
                    !concession &&
                    parseFloat(totalAmountPaid) > parseFloat(totalAmountPayable)
                  ) {
                    totalAmountPaidError =
                      "Amount Paid can't greater than the store payment";
                  }
                } else if (includeRefundBalance) {
                  if (
                    (!totalAmountPaid ||
                      totalAmountPaid === "" ||
                      isNaN(parseFloat(totalAmountPaid))) &&
                    amountPending !== 0
                  ) {
                    totalAmountPaidError = "Amount Paid is required";
                  } else if (parseFloat(totalAmountPaid) < 0) {
                    totalAmountPaidError = "Amount Paid cannot be negative";
                  } else if (
                    amountPayableAfterConcession &&
                    parseFloat(totalAmountPaid) > amountPayableAfterConcession
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed amount after concession";
                  } else if (
                    !concession &&
                    parseFloat(totalAmountPaid) > parseFloat(totalAmountPayable)
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed annual subscription payment";
                  }
                }

                if (
                  (paymentModeName === "UPI" ||
                    paymentModeName === "DD/Cheque") &&
                  (!utrId || utrId.trim() === "")
                ) {
                  transactionIdError =
                    paymentModeName === "DD/Cheque"
                      ? "DD/Cheque number is required."
                      : "Transaction ID is required.";
                }

                // Validate payment date
                if (!paymentDate) {
                  dateofbirthError = "Payment date is required";
                }

                // Validate payment mode
                if (
                  !paymentModeName ||
                  paymentModeName === "" ||
                  parseFloat(paymentModeName) === 0
                ) {
                  paymentModeError = "Payment Mode is required";
                }
                console.log("payment mode:", paymentModeName);

                // Set errors and stop form submission if there are any errors
                if (
                  totalAmountPaidError ||
                  dateofbirthError ||
                  paymentModeError ||
                  amountPayableError ||
                  transactionIdError ||
                  salesIdError
                ) {
                  setTotalAmountPaidError(totalAmountPaidError);
                  setDateofbirthError(dateofbirthError);
                  setPaymentModeError(paymentModeError);
                  setAmountPayableError(amountPayableError);
                  setTransactionIdError(transactionIdError);
                  setsalesIdError(salesIdError);
                  return;
                }

                // Clear errors if no issues
                setTotalAmountPaidError("");
                setConcessionError("");
                setDateofbirthError("");
                setPaymentModeError("");
                setAmountPayableError("");
                setTransactionIdError("");
                setsalesIdError("");

                setSnackbarMessage("OTP sent successfully.");
                setSnackbarMessageColor("success");
                setShowSnackbarMessage(true);
                handleGetOtp();
              } else {
                addPaymentDetails();
              }
            }}
            style={{ alignSelf: "flex-end" }}
            backgroundColor="#0A64A2"
          >
            {isLoading ? "Saving..." : storePaymentId ? "Update" : "Save"}
          </Button>
        </Stack>
      </Stack>
      <br />
      <div className="main_title">Store Payment of {studentName}</div>

      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 700 }}
          aria-label="customized table"
          size="medium"
        >
          <TableHead>
            <TableRow className="table-header">
              <TableCell
                sortDirection={
                  orderBy === "annual_subscription_payment_id" ? order : false
                }
                align="center"
              >
                <TableSortLabel
                  active={orderBy === "store_payment_id"}
                  direction={orderBy === "store_payment_id" ? order : "desc"}
                  onClick={(event) =>
                    handleRequestSort(event, "store_payment_id")
                  }
                  className="table-sort-label"
                >
                  Store Payment ID
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "sales_id" ? order : false}
              >
                <TableSortLabel
                  active={orderBy === "sales_id"}
                  direction={orderBy === "sales_id" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "sales_id")}
                  className="table-sort-label-addontype"
                >
                  Intent ID
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "amount_paid" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "amount_paid"}
                  direction={orderBy === "amount_paid" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "amount_paid")}
                  className="table-sort-label"
                >
                  Amount Paid
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "refund_amount_used" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "refund_amount_used"}
                  direction={orderBy === "refund_amount_used" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "refund_amount_used")
                  }
                  className="table-sort-label"
                >
                  Refund Used
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "amount_pending" ? order : false}
                className="table-cell"
              >
                <TableSortLabel
                  active={orderBy === "amount_pending"}
                  direction={orderBy === "amount_pending" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "amount_pending")
                  }
                  className="table-sort-label"
                >
                  Amount Pending
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "payment_date" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "payment_date"}
                  direction={orderBy === "payment_date" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "payment_date")}
                  className="table-sort-label"
                >
                  Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "payment_mode_name" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "payment_mode_name"}
                  direction={orderBy === "payment_mode_name" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "payment_mode_name")
                  }
                  className="table-sort-label"
                >
                  Payment Mode
                </TableSortLabel>
              </TableCell>

              <TableCell
                align="center"
                sortDirection={orderBy === "description" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "description"}
                  direction={orderBy === "description" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "description")}
                  className="table-sort-label-desc"
                >
                  Description
                </TableSortLabel>
              </TableCell>
              <TableCell align="center" className="table-sort-label-recipt">
                Status
              </TableCell>
              <TableCell align="center" className="table-sort-label-recipt">
                Issued
              </TableCell>
              <TableCell align="center" className="table-sort-label-recipt">
                Receipt
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((paymentRow) => {
              return (
                <TableRow
                  key={paymentRow.store_payment_id}
                  onClick={(event) => {
                    if (event.target.type !== "checkbox") {
                      handleSelectRow(
                        paymentRow.store_payment_id,
                        paymentRow.sales_id,
                        paymentRow.amount_payable,
                        paymentRow.concession,
                        paymentRow.amount_paid,
                        paymentRow.amount_pending,
                        paymentRow.payment_date,
                        paymentRow.payment_mode_name,
                        paymentRow.payment_mode_id,
                        paymentRow.refund_amount,
                        paymentRow.refund_amount_used,
                        paymentRow.transaction_id,
                        paymentRow.description,
                      );
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell component="th" scope="row" align="center">
                    {paymentRow.store_payment_id}
                  </TableCell>
                  <TableCell align="center">{paymentRow.sales_id}</TableCell>
                  <TableCell align="center">{paymentRow.amount_paid}</TableCell>
                  <TableCell align="center">
                    {paymentRow.refund_amount_used}
                  </TableCell>
                  <TableCell align="center">
                    {paymentRow.amount_pending}
                  </TableCell>
                  <TableCell align="center">
                    {paymentRow.payment_date}
                  </TableCell>
                  <TableCell align="center">
                    {paymentRow.payment_mode_name}
                    {paymentRow.transaction_id && (
                      <>
                        <br />({paymentRow.transaction_id})
                      </>
                    )}
                  </TableCell>
                  <TableCell align="center">{paymentRow.description}</TableCell>
                  <TableCell align="center">{paymentRow.sale_status}</TableCell>

                  <TableCell align="center">
                    {paymentRow.sale_status === "Issued" ||
                    paymentRow.sale_status === "Refunded" ||
                    paymentRow.sale_status === "Partial Refund" ? (
                      <CheckBoxIcon
                        style={{ color: "rgb(143 134 134 / 87%)" }}
                      ></CheckBoxIcon>
                    ) : (
                      <Checkbox
                        checked={!!checkedStates[paymentRow.store_payment_id]} // Ensure the value is boolean
                        onChange={() => handleDialogOpen(paymentRow)} // Open dialog
                        disabled={!!disabledStates[paymentRow.store_payment_id]} // Disable if checked
                      />
                    )}
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      variant="text"
                      onClick={(event) => handleDownload(paymentRow, event)}
                      startIcon={<DownloadIcon />}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow className="table-header">
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                count={storePayment.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                className="table-pagination"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          className="alert"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
        <Box className="modalStyle">
          {/* Close Button in the top-right corner */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            style={{ position: "absolute", top: 7, right: 10 }}
          >
            <CloseIcon />
          </IconButton>

          <h3 className="enter-otp">Enter OTP</h3>
          <Divider className="divider" />
          {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

          {/* OTP Input Boxes */}
          <div className="otp-container">
            {otp.map((data, index) => (
              <TextField
                autoFocus={index === 0}
                key={index}
                value={data}
                onChange={(e) => handleOtpChange(e, index)}
                inputProps={{
                  maxLength: 1,
                  id: `otp-input-${index}`, // Set id for focus management
                  style: {
                    textAlign: "center", // Center the text inside
                    fontSize: "17px", // Font size adjustment
                    width: "40px", // Set width and height equal to make it square
                    height: "40px", // Set width and height equal to make it square
                    padding: 0, // Remove default padding
                    boxSizing: "border-box", // Ensure borders don't affect the box size
                  },
                }}
                InputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: 0, // Remove extra padding to keep it square
                  },
                }}
              />
            ))}
          </div>

          {/* Verify and Resend OTP Message */}
          <div className="otp-btn-container">
            {/* Resend OTP Control */}
            {canResend ? (
              <p
                className="resend-otp"
                style={{ color: "green", cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend OTP {resendCount}/3
              </p>
            ) : (
              <p style={{ color: "red" }}>
                Resend OTP in {formatTime(resendTimer)}
              </p>
            )}

            <Button
              variant="contained"
              onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
              className="verify-btn"
            >
              Verify
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleDialogConfirm}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={handleDialogClose}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={handleDialogClose}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
